export enum Validator {
  NOT_NULL = 'NotNullValidator',
  NOT_EMPTY = 'NotEmptyValidator',
  EMAIL = 'EmailValidator',
  EMAILS = 'EmailsValidator',
  OFFER_NUMBER = 'OfferNumber'
}
